import { render, staticRenderFns } from "./golden-booth-dialog.vue?vue&type=template&id=730807a2&scoped=true"
import script from "./golden-booth-dialog.vue?vue&type=script&lang=js"
export * from "./golden-booth-dialog.vue?vue&type=script&lang=js"
import style0 from "./golden-booth-dialog.vue?vue&type=style&index=0&id=730807a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730807a2",
  null
  
)

export default component.exports